export const obfuscateString = (str: string) => {
  if (!str) return str;
  return str.replace(/.(?=.{4})/g, "*");
};
